import React, { useCallback, useEffect, useState } from 'react';
import { Extensions } from 'components/extensions.jsx';
import { useForeground } from '#/hooks/use-foreground.js';

/**
 * @name BrowserApp
 * @param props
 * @return {JSX.Element|null}
 * @constructor
 */
export default function BrowserApp(props) {
  const {
    isPaused = false,
    // isStarted = false,
    debugMode = false,
    object: currentObject,
  } = props;

  const ref = React.useRef(null);
  const [isSmall, setIsSmall] = useState(false);

  useForeground(ref, currentObject);

  {
    const onResize = useCallback(() => {
      const wrapper = document.querySelector('.wrapper');
      const isSmall = wrapper ? wrapper.offsetHeight < 270 : false;
      setIsSmall(isSmall);
    }, []);

    useEffect(() => {
      onResize();
      window.addEventListener('resize', onResize);

      return () => {
        window.removeEventListener('resize', onResize);
      };
    }, [onResize]);
  }

  // TODO: update the same conditions from other platforms
  if (currentObject === null) {
    /* interactive does not start for any object yet */
    return null;
  }

  return (
    <div
      className="App web"
      data-hidden={isPaused}
      data-debug={debugMode}
      ref={ref}
    >
      <div className={`wrapper ${isSmall ? 'small' : ''}`}>
          {/*
              Attention !!!
              Due to Emoji module almost non-interactive it MUST be below Poll layer

              К сожалению эта проблема не решена для расширений.
              TODO: Для нормльного отображения poll vs. emoji нужно явно прописать в списке расширений в consul
               poll __до__ empoji, это необходимо как-то исправить
            */}
          <Extensions currentObject={currentObject} />
      </div>
    </div>
  );
}
